import type { Dossier } from '@/mocks/dossiers';

export default function ConnectionSection({ dossier }: { dossier: Dossier }) {
  return (
    <section id="connections" className="scroll-mt-24">
      <header className="flex flex-wrap items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-800 text-background-50">
          <i className="ri-node-tree text-lg" />
        </span>
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">事件隐藏关联</h2>
      </header>
      <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
        把两处看起来无关的内容左右并列，连线就自己出现了。
      </p>

      <ul className="mt-8 space-y-4">
        {dossier.connections.map((item) => (
          <li key={item.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
              <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
              <div className="flex flex-wrap items-center gap-2">
                <span className="whitespace-nowrap rounded-md border border-secondary-200 bg-secondary-50 px-3 py-1 font-label text-xs text-secondary-800">
                  {item.a}
                </span>
                <i className="ri-link text-secondary-500" />
                <span className="whitespace-nowrap rounded-md border border-secondary-200 bg-secondary-50 px-3 py-1 font-label text-xs text-secondary-800">
                  {item.b}
                </span>
              </div>
            </div>
            <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}